import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';

export type NotificationType = 'success' | 'info' | 'notice' | 'error';

export interface NotificationDef {
  id: string;
  icon?: React.ReactNode;
  title: string;
  message: string;
  type: NotificationType;
  autoClose?: boolean;
  closeDuration?: number;
  hightContrast?: boolean;
}

interface NotificationsState {
  notifications: NotificationDef[];
  setNotifications: (notifications: NotificationDef[]) => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  notifications: [],
  setNotifications: (notifications) => set({ notifications }),
}));

export namespace Notifications {
  export const show = (notification: Omit<NotificationDef, 'id'>) => {
    const id = uuidv4();
    const store = useNotificationsStore.getState();
    const newNotification = { ...notification, id };

    store.setNotifications([...store.notifications, newNotification]);
  };

  export const hide = (id: string) => {
    const store = useNotificationsStore.getState();
    store.setNotifications(store.notifications.filter((notification) => notification.id !== id));
  };
}
